import { useEffect, useState } from "react";

import { useTheme } from "next-themes";
import { customLoginButton, themeBasedSignupFormControl } from "../components/customStyles";
import Select from "react-select";

import DcclLogo from "./../assets/DCCL-Logo.png";
import { getStaticSignupData, signupUser } from "../services/auth.service";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";

import LogoDark from "../assets/InvestorApp.png";

import "./../styles/forms.css";
import { useI18n } from "../hooks/useI18n";

const salutationOptions = [
  { value: "Mr", label: "Mr" },
  { value: "Mrs", label: "Mrs" },
  { value: "Ms", label: "Ms" },
];

const apiOptions = {
  method: "GET",
  headers: {
    Authorization: process.env.REACT_APP_API_GUEST_TOKEN,
  },
};

function capitalizeFirstLetter(sentence) {
  return sentence
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function formatCNIC(value) {
  let digits = "";

  for (const x of value) {
    if (x >= "0" && x <= "9") {
      digits += x;
    }
  }

  let formatted = "";

  [...digits].forEach((x, i) => {
    if (i === 5 || i === 12) {
      formatted += "-";
    }

    formatted += x;
  });

  if (formatted.length >= 16) return formatted.slice(0, 15);

  return formatted;
}

function formatMobile(value) {
  let digits = "";

  for (const x of value) {
    if (x >= "0" && x <= "9") {
      digits += x;
    }
  }

  let formatted = "";

  [...digits].forEach((x, i) => {
    if (i === 4) {
      formatted += "-";
    }

    formatted += x;
  });

  if (formatted.length >= 13) return formatted.slice(0, 12);

  return formatted;
}

const Signup = () => {
  const [screenSize, setScreenSize] = useState();
  const [formSteps, setFormSteps] = useState(1);

  const [registerFormData, setRegisterFormData] = useState(() => ({
    salutations: "",
    name: "",
    father_name: "",
    gender: "Male",
    occupation: "",
    user_email: "",
    mobile: "",
    cnic: "",
    cnic_issue: "",
    lifetime_cnic: false,
    cnic_expiry: "",
    address: "",
    city: "",
    province: "",
    country: "",
  }));

  const [registerFormErrors, setRegisterFormErrors] = useState(() => ({
    user_email: false,
    cnic: false,
    mobile: false,
  }));

  const [requiredFieldValue, setRequiredFieldValue] = useState(() => ({
    occupations: [],
    provinces: [],
    cities: [],
    countries: [],
  }));

  const [formProcessing, setFormProcessing] = useState(false);

  const { theme } = useTheme();
  const { isRTL } = useI18n();

  const navigate = useNavigate();

  const updateFormData = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;

      if (e) {
        setRegisterFormData((prev) => ({ ...prev, [name]: e }));
      } else {
        setRegisterFormData((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      const { name, value } = e.target;

      if (name === "cnic") {
        setRegisterFormData((prev) => ({ ...prev, [name]: formatCNIC(value) }));
      } else if (name === "mobile") {
        setRegisterFormData((prev) => ({ ...prev, [name]: formatMobile(value) }));
      } else if (name === "lifetime_cnic") {
        const { checked } = e.target;

        if (checked) {
          setRegisterFormData((prev) => ({ ...prev, cnic_expiry: "9999-12-31" }));
        } else {
          setRegisterFormData((prev) => ({ ...prev, cnic_expiry: "" }));
        }

        setRegisterFormData((prev) => ({ ...prev, [name]: checked }));
      } else {
        setRegisterFormData((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  // const constructParams = (options) => {

  // 	const params = "?";

  // 	for (const key in options) {
  // 		params += ""
  // 	}
  // }

  const submitRegisterForm = async (e) => {
    e.preventDefault();

    try {
      setFormProcessing(true);

      const localErrorObject = {};

      const { user_email, mobile, cnic, name } = registerFormData;

      const allEmpty = !user_email || !mobile || !cnic;

      if (allEmpty) {
        setRegisterFormErrors(() => ({
          user_email: true,
          cnic: true,
          mobile: true,
        }));

        toast((t) => customToast(t("auth.messages.error.missing"), "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            width: "340px",
            maxWidth: "100%",
            // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
            // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
            color: "rgb(33,37,41)",
            backgroundColor: "rgb(221, 204, 225)",
          },
        });

        return;
      }

      if (mobile.length !== 12) {
        localErrorObject.mobile = "Please enter a valid Phone Number";
        setRegisterFormErrors((prev) => ({ ...prev, mobile: true }));
      } else {
        delete localErrorObject.mobile;
        setRegisterFormErrors((prev) => ({ ...prev, mobile: false }));
      }

      if (cnic.length !== 15) {
        localErrorObject.cnic = "Please enter a valid CNIC";
        setRegisterFormErrors((prev) => ({ ...prev, cnic: true }));
      } else {
        delete localErrorObject.cnic;
        setRegisterFormErrors((prev) => ({ ...prev, cnic: false }));
      }

      if (Object.keys(localErrorObject).length !== 0) {
        for (const error in localErrorObject) {
          toast((t) => customToast(localErrorObject[error], "error", t), {
            duration: 3000,
            removeDelay: 1000,
            style: {
              padding: "0.75rem",
              margin: "0",
              width: "340px",
              maxWidth: "100%",
              // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
              // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
              color: "rgb(33,37,41)",
              backgroundColor: "rgb(221, 204, 225)",
            },
          });
        }

        return;
      }

      setRegisterFormErrors(() => ({
        user_email: false,
        cnic: false,
        mobile: false,
      }));

      await new Promise((res) => setTimeout(() => res(), 1000));

      const argsData = {
        ...registerFormData,
        gender: registerFormData.salutations === "MR" ? "Male" : "Female",
      }

      const response = await signupUser(argsData);

      if (!response.error) {
        toast((t) => customToast(response.message, "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            width: "340px",
            maxWidth: "100%",
            // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
            // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
            color: "rgb(33,37,41)",
            backgroundColor: "rgb(221, 204, 225)",
          },
        });

        navigate("/auth/login", { state: { email: registerFormData.user_email, mobile_number: registerFormData.mobile } });
      } else {
        toast((t) => customToast(response.message, "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            width: "260px",
            maxWidth: "100%",
            // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
            // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
            color: "rgb(33,37,41)",
            backgroundColor: "rgb(221, 204, 225)",
          },
        });
      }
    } finally {
      setFormProcessing(false);
    }
  };

  useEffect(() => {
    const resizeScreen = () => {
      setScreenSize(window?.innerWidth);
    };

    resizeScreen();

    window.addEventListener("resize", resizeScreen);

    // const fillRequiredFormFieldValues = async () => {
    //   // const responseData = {};
    //   const citiesSelectFormat = [];
    //   const countriesSelectFormat = [];
    //   const occupationsSelectFormat = [];

    //   const occupations = await getStaticSignupData("/static/occupations", apiOptions);
    //   const provinces = await getStaticSignupData("/static/provincies", apiOptions);
    //   const cities = await getStaticSignupData("/static/cities", apiOptions);
    //   const countries = await getStaticSignupData("/static/countries", apiOptions);
    //   // responseData.glossary = await apiCall('/glossary');
    //   // responseData.faq = await apiCall('/faq');

    //   !cities.err &&
    //     cities.data.forEach((city) => {
    //       const withoutCode = city.name.slice(city.name.indexOf(" ") + 1);

    //       citiesSelectFormat.push({ value: city, label: capitalizeFirstLetter(withoutCode), province: city.province });
    //     });

    //   !countries.err &&
    //     countries.data.forEach((country) => {
    //       const withoutCode = country.slice(country.indexOf(" ") + 1);

    //       countriesSelectFormat.push({ value: country, label: withoutCode });
    //     });

    //   !occupations.err &&
    //     occupations.data.forEach((occupation) => {
    //       const withoutCode = occupation.slice(occupation.indexOf(" ") + 1);

    //       occupationsSelectFormat.push({ value: occupation, label: withoutCode });
    //     });

    //   const responseData = {
    //     cities: citiesSelectFormat.sort((a, b) => a.label.localeCompare(b.label)),
    //     countries: countriesSelectFormat.sort((a, b) => a.label.localeCompare(b.label)),
    //     occupations: occupationsSelectFormat.sort((a, b) => a.label.localeCompare(b.label)),
    //     provinces: !provinces.err ? provinces.data.sort((a, b) => a.label.localeCompare(b.label)) : [],
    //   };

    //   setRequiredFieldValue(responseData);
    // };

    // fillRequiredFormFieldValues();

    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  }, []);

  // console.log(requiredFieldValue);
  // console.log(registerFormData);

  return (
    <div
      className={`add-custom-scroll${theme === "dark" ? "-dark" : ""} container-fluid w-100 d-flex mx-auto flex-column justify-content-start flex-nowrap`}
      style={{
        fontFamily: isRTL ? "var(--font-urdu)" : '"Barlow Condensed", "Kanit"',
        backgroundColor: "var(--theme-bg)",
        padding: screenSize <= 575 ? "8px 8px 8px 8px" : "4px 10px 10px 12px",
        borderRadius: "20px",
        rowGap: "8px",
        height: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
        overflowY: "auto",
      }}
    >
      <div className='row w-100 flex-column align-items-center justify-content-between mx-auto py-3 flex-nowrap' style={{
        height: '100%',
        minHeight: '700px'
      }}>
        <div
          className='col-auto p-0 d-flex flex-column justify-content-center align-items-center text-center'
          style={{
            flex: "1 0 200px",
          }}
        >
          <img
            className=''
            src={LogoDark}
            style={{
              width: "300px",
              objectFit: "contain",
              maxWidth: "100%",
            }}
          />
        </div>
        <div
          className='col-auto p-0 px-2 d-flex flex-column justify-content-center mb-5'
          style={{
            flex: "1",
          }}
        >
          <div>
            <div className='logo-container'>
              <p className='brand-subtitle'>Create your account and start investing</p>
            </div>

            <div className='registration-card'>
              <form id='registrationForm' onSubmit={submitRegisterForm}>
                {formSteps === 1 ? (
                  <>
                    <div className='row g-3'>
                      <div className='col-md-6'>
                        <div className='form-floating'>
                          <select className='form-select' id='salutations' name='salutations' onChange={updateFormData}>
                            <option value=''>Choose...</option>
                            <option value='MR'>Mr.</option>
                            <option value='MS'>Ms.</option>
                            <option value='MRS'>Mrs.</option>
                            {/* <option value='dr'>Dr.</option> */}
                          </select>
                          <label htmlFor='salutation'>Salutation</label>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='form-floating position-relative'>
                          <input type='text' className='form-control' id='name' name='name' placeholder='Full Name' onChange={updateFormData} required />
                          <label htmlFor='name'>Full Name *</label>
                          <i className='fas fa-user input-group-icon'></i>
                        </div>
                      </div>
                    </div>

                    <div className='form-floating position-relative'>
                      <input type='text' className='form-control' id='father_name' name='father_name' placeholder="Father's Name" onChange={updateFormData} />
                      <label htmlFor='fatherName'>Father's Name</label>
                      <i className='fas fa-male input-group-icon'></i>
                    </div>

                    {/* <div className='mb-3'>
                      <label className='form-label text-secondary fw-semibold'>Gender *</label>
                      <div className='gender-options'>
                        <div className='gender-option'>
                          <input type='radio' id='male' name='gender' value='male' required />
                          <label htmlFor='male'>
                            <i className='fas fa-mars me-2'></i>Male
                          </label>
                        </div>
                        <div className='gender-option'>
                          <input type='radio' id='female' name='gender' value='female' required />
                          <label htmlFor='female'>
                            <i className='fas fa-venus me-2'></i>Female
                          </label>
                        </div>
                      </div>
                    </div> */}

                    {/* <div className='form-floating position-relative'>
                      <select className='form-select' id='occupation' name='occupation'>
                        <option value=''>Select Occupation...</option>
                        <option value='student'>Student</option>
                        <option value='teacher'>Teacher</option>
                        <option value='engineer'>Engineer</option>
                        <option value='doctor'>Doctor</option>
                        <option value='business'>Business</option>
                        <option value='other'>Other</option>
                      </select>
                      <label htmlFor='occupation'>Occupation</label>
                    </div> */}

                    <div className='form-floating position-relative'>
                      <input type='email' className='form-control' id='user_email' name='user_email' placeholder='Email Address' onChange={updateFormData} required />
                      <label htmlFor='user_email'>Email Address *</label>
                      <i className='fas fa-envelope input-group-icon'></i>
                    </div>

                    <div className='form-floating position-relative'>
                      <input type='text' className='form-control' id='mobile' name='mobile' placeholder='Mobile Number' value={registerFormData.mobile} onChange={updateFormData} required />
                      <label htmlFor='mobile'>Mobile Number *</label>
                      <i className='fas fa-phone input-group-icon'></i>
                    </div>

                    <div className='form-floating position-relative'>
                      <input type='text' className='form-control' id='cnic' name='cnic' placeholder='CNIC Number' value={registerFormData.cnic} onChange={updateFormData} required />
                      <label htmlFor='cnic'>CNIC Number *</label>
                      <i className='fas fa-id-card input-group-icon'></i>
                    </div>

                    <div className='row g-3 mb-3'>
                      <div className='col-md-6'>
                        <div className='form-check'>
                          <input className='form-check-input' type='checkbox' id='lifetime_cnic' name='lifetime_cnic' onChange={updateFormData} />
                          <label className='form-check-label' htmlFor='lifetime_cnic'>
                            Lifetime CNIC
                          </label>
                        </div>
                      </div>
                      {!registerFormData.lifetime_cnic ? (
                        <div className='col-md-6'>
                          <div className='form-floating m-0'>
                            <input type='date' className='form-control' id='cnic_expiry' name='cnic_expiry' onChange={updateFormData} />
                            <label htmlFor='cnicExpiry'>CNIC Expiry Date</label>
                          </div>
                        </div>
                      ) : ''}
                    </div>

                    {/* <div className='form-floating'>
                      <textarea className='form-control' id='address' name='address' placeholder='Address' style={{ height: "100px" }} />
                      <label htmlFor='address'>Address</label>
                    </div> */}
                  </>
                ) : (
                  <>
                    <div className='row g-3'>
                      <div className='col-md-6'>
                        <div className='form-floating'>
                          <select className='form-select' id='city' name='city'>
                            <option value=''>Select City...</option>
                            <option value='islamabad'>Islamabad</option>
                            <option value='karachi'>Karachi</option>
                            <option value='lahore'>Lahore</option>
                            <option value='rawalpindi'>Rawalpindi</option>
                            <option value='faisalabad'>Faisalabad</option>
                          </select>
                          <label htmlFor='city'>City</label>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='form-floating'>
                          <select className='form-select' id='province' name='province'>
                            <option value=''>Select Province...</option>
                            <option value='punjab'>Punjab</option>
                            <option value='sindh'>Sindh</option>
                            <option value='kpk'>Khyber Pakhtunkhwa</option>
                            <option value='balochistan'>Balochistan</option>
                            <option value='ict'>Islamabad Capital Territory</option>
                          </select>
                          <label htmlFor='province'>Province</label>
                        </div>
                      </div>
                    </div>

                    <div className='form-floating'>
                      <select className='form-select' id='country' name='country'>
                        <option value=''>Select Country...</option>
                        <option value='pakistan' selected>
                          Pakistan
                        </option>
                        <option value='india'>India</option>
                        <option value='bangladesh'>Bangladesh</option>
                        <option value='uae'>United Arab Emirates</option>
                        <option value='usa'>United States</option>
                        <option value='uk'>United Kingdom</option>
                      </select>
                      <label htmlFor='country'>Country</label>
                    </div>
                  </>
                )}

                <button type='submit' className={`btn btn-signup` + (formProcessing ? " disabled" : "")} style={{
                  ["--bs-btn-disabled-color"]: "rgba(255,255,255,.9)"
                }}>
                  {formProcessing ? (
                    <>
                      <span
                        className='spinner-border spinner-border-sm me-1'
                        aria-hidden='true'
                        style={{
                          fontSize: "0.85rem",
                          height: screenSize >= 576 ? "15px" : "14px",
                          width: screenSize >= 576 ? "15px" : "14px",
                        }}
                      ></span>
                    <span role='status' className="ms-2">{"Loading ..."}</span>
                    </>
                  ) : (
                    "Create Account"
                  )}
                  {/* <i className='fas fa-user-plus me-2'></i>Create Account */}
                </button>

                <div className='text-center mt-3'>
                  <p className='form-text'>
                    Already have an account?{" "}
                    <Link to="/auth/login" className='text-decoration-none fw-semibold' style={{ color: "#667eea" }}>
                      Sign in here
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          className='col-auto p-0'
          style={{
            flex: "1 0 ",
          }}
        >
          <div
            className='text-center'
            style={{
              lineHeight: "1",
              fontSize: "1.2rem",
              color: "rgba(255,255,255,0.7)",
            }}
          >
            Powered by
          </div>
          <img
            className=''
            src={DcclLogo}
            alt='Logo'
            style={{
              width: "160px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Signup;
